import { defineStore } from 'pinia'
import Cookies from 'js-cookie'
import apiClient from '../utils/axiosConfig'

const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN

export function setAppCookie(name: string, value: string) {
  console.log('setAppCookie', name, value)
  console.log('domain', COOKIE_DOMAIN)
  Cookies.set(name, value, {
    path: '/',
    domain: COOKIE_DOMAIN,
    secure: false,
    sameSite: 'Lax',
  })
}

// Funktion zum Entfernen eines Cookies
export function removeAppCookie(name: string) {
  Cookies.remove(name, {
    path: '/',
    domain: COOKIE_DOMAIN,
  })
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    authentificated: false,
    token: '', // Store the token
    data: {
      roles: [] as string[], // ✅ Define as empty array of strings
      username: '',
      email: '',
      twofa_enabled: false,
    },
  }),

  actions: {
    // Login action
    async login(username: string, password: string, otp_code: string = '') {
      try {
        // Make an API call to authenticate the user
        const formData = new URLSearchParams()
        formData.append('username', username)
        formData.append('password', password)
        formData.append('otp_code', otp_code)
        formData.append('otp_time', new Date().toISOString()) // TimeStamp

        const response = await apiClient.post('/auth/login', formData, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })

        if (response.data && response.data.access_token) {
          setAppCookie('authToken', response.data.access_token)

          // Update the store state
          this.authentificated = true
          this.token = response.data.access_token
          this.data = response.data.user
        } else {
          throw new Error('Invalid login response')
        }
      } catch (error) {
        console.error('Login failed:', error)
        this.authentificated = false
        this.token = ''
        removeAppCookie('authToken')

        throw error

        //Cookies.remove('authToken') // Remove token on failure
      }
    },

    // Logout action
    logout() {
      this.authentificated = false
      this.token = ''
      this.data = { roles: [], username: '', email: '', twofa_enabled: false } // Reset user data
      removeAppCookie('authToken')

      //Cookies.remove('authToken') // Remove the token from cookies
    },

    // Check if the token is valid
    async validateToken() {
      const token = Cookies.get('authToken')
      if (token) {
        try {
          // Optionally, make an API call to validate the token
          const response = await apiClient.get('user/me', {
            headers: { Authorization: `Bearer ${token}` },
          })

          if (response.status === 200) {
            this.authentificated = true
            this.data = await response.data
            this.token = token
            console.log('Token is valid!')
          } else {
            throw new Error('Token is not valid')
          }
        } catch (error) {
          console.error('Token validation failed:', error)
          this.authentificated = false

          this.token = ''
          this.data = { roles: [], username: '', email: '', twofa_enabled: false } // Reset user data
          removeAppCookie('authToken')
          //Cookies.remove('authToken') // Remove invalid token
        }
      }
    },

    // Initialization action to check if the user is already authenticated
    async initializeAuth() {
      const token = Cookies.get('authToken')
      if (token) {
        this.token = token
        await this.validateToken() // Validate the token on store load
        console.log('token', this.data)
      }
    },

    hasRole(role: string) {
      if (this.data) {
        // Safely check if roles exist and include the specified role
        if (Array.isArray(this.data.roles)) {
          if (this.data.roles?.includes('root')) return true

          return this.data.roles?.some((userRole: string) => userRole === role)
        }
      }
      return false
    },

    hasOneRole(roles: string | string[]) {
      if (!this.data || !Array.isArray(this.data.roles)) return false

      if (this.data.roles.includes('root')) return true

      const roleList = Array.isArray(roles) ? roles : [roles]

      return roleList.some((role) => this.data.roles.includes(role))
    },
  },
})
